import { Inject, Injectable, InjectionToken, Optional } from '@angular/core';
import { CIPXDrawerContentInterface } from '@sbd-doug-frontend/shared/lib/ui/drawer/drawer-content.interface';
import { DrawerRef } from '@sbd-doug-frontend/shared/lib/ui/drawer/drawer-manager.service';
import { PersistentDrawerTab } from './persistent-drawer-tabs.service';

export interface PersistentDrawerOpener {
  type: string;
  open(tab: PersistentDrawerTab): DrawerRef<CIPXDrawerContentInterface<any>>;
}

export const PERSISTENT_DRAWER_OPENERS = new InjectionToken<PersistentDrawerOpener[]>('PERSISTENT_DRAWER_OPENERS');

@Injectable({
  providedIn: 'root',
})
export class PersistentDrawerRegistryService {
  private readonly _openers = new Map<string, PersistentDrawerOpener>();

  constructor(@Optional() @Inject(PERSISTENT_DRAWER_OPENERS) openers: PersistentDrawerOpener[] | null) {
    (openers ?? []).forEach((opener) => this.register(opener));
  }

  register(opener: PersistentDrawerOpener): void {
    this._openers.set(opener.type, opener);
  }

  open(tab: PersistentDrawerTab): DrawerRef<CIPXDrawerContentInterface<any>> | null {
    return this._openers.get(tab.type)?.open(tab) ?? null;
  }
}
